import React from 'react';

const MarriageDateDescription = (
  <div className="vads-u-margin-top--4">
    <p>
      <strong>Note:</strong> We may ask you to upload your marriage certificate
      if one of these apply to you:
    </p>
    <ul>
      <li>
        You recently got married and need to add your spouse to our system,{' '}
        <strong>or</strong>
      </li>
      <li>You have stepchildren you wish to enroll in CHAMPVA</li>
    </ul>
  </div>
);

export default MarriageDateDescription;
